import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconExternalLinkAltSvg } from "./IconExternalLinkAltSvg.mjs";
const IconExternalLinkAlt = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconExternalLinkAltSvg, ...iconProps });
};
export {
  IconExternalLinkAlt
};
